module.exports = __webpack_public_path__ + "static/media/vtex28.acfaa38c.png";